import React from 'react'

import { IAddressProps } from './interfaces'

import { Container, Icon, Heading, Content, Action } from './styles'

const Address: React.FC<IAddressProps> = ({
  title = 'Endereço cadastrado',
  ...props
}) => {
  if (!props.street) return null

  return (
    <Container>
      <Icon />

      <Content>
        <Heading>{title}</Heading>
        {props.street}, {props.number} - {props.neighborhood}.
        <br />
        {props.city}, {props.state}. {props.zipcode}.
        <br />
        {props.complement}
        {props.action && (
          <Action onClick={props.action.handler}>{props.action.text}</Action>
        )}
      </Content>
    </Container>
  )
}

export default Address
